import { render, staticRenderFns } from "./FormRecoveryPassword.vue?vue&type=template&id=ad0423f4"
import script from "./FormRecoveryPassword.vue?vue&type=script&lang=js"
export * from "./FormRecoveryPassword.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports